interface MainContentAreaProps {
  children: React.ReactNode
}

export function MainContentArea({ children }: MainContentAreaProps) {
  return <div className="page-content">{children}</div>
}
